import { render } from "./WaMessageReport.vue?vue&type=template&id=013f276c&scoped=true"
import script from "./WaMessageReport.vue?vue&type=script&lang=js"
export * from "./WaMessageReport.vue?vue&type=script&lang=js"

import "./WaMessageReport.vue?vue&type=style&index=0&id=013f276c&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013f276c"]])

export default __exports__